var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"v-stopwatch"},[_vm._v(_vm._s(_vm.displayTime))])
}
var staticRenderFns = []

export { render, staticRenderFns }